import React from 'react';
import { Navigate } from 'react-router-dom';

const GuestRoute = ({ children }) => {
  const token = localStorage.getItem('auth_token');
  return token ? <Navigate to="/devices" /> : children;
};

export default GuestRoute;
